<template>
  <div class="fundsTransfer" :class="lang">
    <!-- 转出账户 -->
    <div class="ipt-box " :class="{ error: isClickNext && !formData.a_account }">
      <div class="ipt-main" @click="showAccount(1)">
        <div class="val-box">
          <span class="label" :class="{ placeholder: !formData.a_account }">{{ $t('fundsTransfer.f000001') }}</span>
          <div class="val" v-if="formData.a_account">
            <img class="icon" v-if="formData.a_account_type == 1" src="../../../assets/images/app-pages/future.png" >
            <img class="icon" v-if="formData.a_account_type == 2" src="../../../assets/images/app-pages/security.png" >
            <span>{{ formData.a_account_type == 1 ? `${$t('transferInto.accountName[0]')}\n(${formData.a_account})` : `${$t('transferInto.accountName[1]')}\n(${formData.a_account})` }}</span>
          </div>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 资金信息 -->
    <div class="container "> 
      <div class="box left">
        <div class="top">{{ $t("moneyExchange.m000008") }}</div> 
        <div class="bottom">{{ getAmount(accountInfo.usd) }}</div>
      </div>
      <div class="box center">
        <div class="top">{{ $t("moneyExchange.m000009") }}</div>
        <div class="bottom">{{ getAmount(accountInfo.hkd) }}</div>
      </div>
      <div class="box right">
        <div class="top">{{ $t("moneyExchange.m000010") }}</div>
        <div class="bottom">{{ getAmount(accountInfo.cnh) }}</div>
      </div>
    </div>
    <!-- 转入账户 -->
    <div class="ipt-box " :class="{ error: isClickNext && !formData.b_account }">
      <div class="ipt-main" @click="showAccount(2)">
        <div class="val-box">
          <span class="label" :class="{ placeholder: !formData.b_account }">{{ $t('fundsTransfer.f000003') }}</span>
          <div class="val" v-if="formData.b_account">
            <img class="icon" v-if="formData.b_account_type == 1" src="../../../assets/images/app-pages/future.png" >
            <img class="icon" v-if="formData.b_account_type == 2" src="../../../assets/images/app-pages/security.png" >
            <span>{{ formData.b_account_type == 1 ? `${$t('transferInto.accountName[0]')}\n(${formData.b_account})` : `${$t('transferInto.accountName[1]')}\n(${formData.b_account})` }}</span>
          </div>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 港币 -->
    <div class="ipt-box " :class="{ error: isClickNext && !formData.transfer_currency }">
      <div class="ipt-main" @click="showPicker(3)">
        <div class="val-box">
          <span class="label" :class="{ placeholder: !formData.transfer_currency }">{{ $t('fundsTransfer.f000004') }}</span>
          <span class="val" v-if="formData.transfer_currency">{{ coinTypeText }}</span>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 余额 -->
    <div class="ipt-box" :class="{error: isClickNext && !formData.amount, focus: inputFocusId == 4}">
      <div class="ipt-main">
        <div class="val-box">
          <span class="label" v-if="inputFocusId == 4 || formData.amount">{{ $t('fundsTransfer.f000005') }}</span>
          <Field
            class="val"
            clearable
            ref="amountField"
            :readonly="formData.is_all == 1"
            :right-icon="formData.is_all == 1 ? 'clear' : '' "
            :value="displayAmount"
            :placeholder="inputFocusId == 4 ? '' : $t('fundsTransfer.f000005')"
            @input="handleAmountInput"
            @focus="inputFocus(4)"
            @blur="inputBlur"
            @click-right-icon="clearAmount"
          ></Field>
        </div>
      </div>
      <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 全部余额 -->
    <div class="tag-btn" :class="{ 'tag-btn-active': formData.is_all == 1 }" v-if="isShowAllAmount" @click="selectedAmount">{{ $t('withdrawNew.lang6') }}</div>
    <nav-buttons
        :isFixed="false"
        :showPrev="false"
        :disabled="isButtonDisabled"
        :nextText="$t('bankTransfer.b000016')"
        @on-next="submit"
    />
    <!-- 验证登录密码弹窗 -->
    <van-dialog v-model="checkPasswordShow"
      class="check-password-dialog"
      :title="$t('fundsTransfer.f000007')" show-cancel-button
      :before-close="handleBeforeClose">
      <div class="verifyLoginPassword">
        <Field class="input" v-model="checkPassword" :type="eyeIsOpen ? 'text' : 'password'" >
          <template #button>
            <img
              src="@/assets/images/app-pages/light_close.png"
              class="eye lightClose"
              v-show="!eyeIsOpen"
              @click="eyeSwitch"
            >
            <img
              src="@/assets/images/app-pages/dark_close.png"
              class="eye darkClose"
              v-show="!eyeIsOpen"
              @click="eyeSwitch"
            >
            <img
              src="@/assets/images/app-pages/light_open.png"
              class="eye lightOpen"
              v-show="eyeIsOpen"
              @click="eyeSwitch"
            >
            <img
              src="@/assets/images/app-pages/dark_open.png"
              class="eye darkOpen"
              v-show="eyeIsOpen"
              @click="eyeSwitch"
            >
          </template>
        </Field>
      </div>
    </van-dialog>
    <!-- 密码错误 -->
    <password-error-prompt
      v-show="pwdErrPromptOption.show"
      :err-code="pwdErrPromptOption.errCode"
      :err-html="pwdErrPromptOption.errHtml" 
      @password-error-prompt-confirm="passwordErrorPromptConfirm"
      ref="password-error-prompt-el"
    ></password-error-prompt>
    <!-- 提交成功提示语 -->
    <van-dialog
      :class="bgColor == 'black-theme' ? 'darkOrLight':'defaultDialog'"
      v-model="submitSuccess"
      :show-confirm-button="false"
      :showCancelButton="false"
      class="m-open-dialog"
    >
      <div class="dialog-main">
        <div class="dialog-title">
          <img src="@/assets/images/open-account/tip_icon.png" class="img-dia" />
        </div>
        <p class="text">{{ $t("fundsTransfer.f000010") }}</p>
        <p class="email"
        >{{ $t("fundsTransfer.f000013") }}</p>
        <div class="foot-dia-btn">
          <div class="dia-btn" @click="okay">{{ $t("transferInto.lang8") }}</div>
        </div>
      </div>
    </van-dialog>
    <!-- 下拉选择弹窗 -->
    <Popup v-model="showPickerPopup" position="bottom" class="picker-popup picker-ui">
      <Picker show-toolbar :default-index="currentDefaultIndex" :columns="currentColumns" @confirm="onPickerConfirm" @cancel="showPickerPopup = false" />
    </Popup>
    <!-- 账号列表 -->
    <ActionSheet
       :title="$t('withdrawNew.lang')"
       v-model="showAccountPicker"
       class="action-sheet-sex"
     >
       <div>
        <template v-if="currentColumns.length">
         <div class="sheet-box" v-for="item in currentColumns" :key="item.account_no" :class="{'active-border': isActive(item)}"  @click="selectAccount(item)">
           <div class="img-box">
             <img :src="item.account_type == 1 ? future : security" class="img-logo">
             <span class="title">{{ item.text }}</span>
           </div>
           <div class="icon-box">
             <Icon :name="rightOK" class="success-icon" size="22" v-if="clickType == 1 && item.account_no == formData.a_account" color="#EA3447"  />
             <Icon :name="rightOK" class="success-icon" size="22" v-if="clickType == 2 && item.account_no == formData.b_account" color="#EA3447"  />
           </div>
         </div>
        </template>
        <div class="empty-box" v-else>
          <img src="@/assets/images/app-pages/recordEmpty.png" alt="no data" class="empty-img">
          <p class="empty-text">{{ $t('bankTransfer.b000019') }}</p>
        </div>
       </div>
    </ActionSheet>
  </div>
</template>

<script>
import { Picker, Popup, Field, Dialog, ActionSheet, Icon }  from "vant";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import { localeString, validateInput } from '@/utils/utils.new';
import future from "@/assets/images/open-account/future.png";
import security from "@/assets/images/open-account/security.png";
import navButtons from '../components/navButtons.vue';
import { webViewRightButton, closeWebView } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
import rightOK from '@/assets/images/app-pages/right_ok.png'
export default {
  name: 'fundsTransfer',
  components: { 
    Picker,
    Popup,
    Icon,
    Field,
    [Dialog.Component.name]: Dialog.Component,
    passwordErrorPrompt,
    navButtons,
    ActionSheet,
  },
  data() {
    return {
      rightOK,
      clickType: 1,
      future,
      security,
      depositAccount: [],     // 转入列表
      withdrawalAccount: [],    // 转出列表
      formData: {
        a_account: '',      // 转出账户编号
        b_account: '',      // 转入账户编号
        amount: '',         // 转账金额
        type: '',           // 账户类型
        transfer_currency: '',   // 转账币种
        a_account_type: '',     // 转出账户类型
        b_account_type: '',     // 转入账户类型
        is_all: 0,             //  是否选择“全部”金额
      },
      accountInfo: {            // 账户金额
        usd: '',
        hkd: '',
        cnh: ''
      },
      isClickNext: false,
      showPickerPopup: false,
      showAccountPicker: false,
      currentColumns: [],
      currentDefaultIndex: 0,
      coinTypeText: '',
      inputFocusId: -1,
      checkPasswordShow: false,
      checkPassword: '',
      eyeIsOpen: false,        // 是否明文显示密码
      pwdErrPromptOption: {
        show: false,
        errCode: -1,
        errHtml: ""
      },
      submitSuccess: false,     // 成功弹窗
      arrenyColumns: [],
      lang: 'zh-CN',    
    }
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    isButtonDisabled() {
      const { a_account_type, b_account_type, transfer_currency, amount } = this.formData;
      return !a_account_type || !b_account_type || !transfer_currency || !amount;
    },
    isShowAllAmount() {
      const balanceMap = {
        'USD': this.accountInfo.usd,
        'HKD': this.accountInfo.hkd,
        'CNH': this.accountInfo.cnh,
      };
      const balance = parseFloat(balanceMap[this.formData.transfer_currency]);
      return balance > 0;
    },
    displayAmount() {
      return this.formData.is_all == 1 ? this.$t('withdrawNew.lang6') : this.formData.amount;
    },
    isActive() {
      return item => {
        return (this.clickType == 1 && item.account_no == this.formData.a_account) || 
            (this.clickType == 2 && item.account_no == this.formData.b_account)
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() { 
      this.getAccountsList();
    },
    getAccountsList() {
        this.$apis.getAuthList().then( res => {
          this.withdrawalAccount = res.accountInfo.map( item => {
            item['text'] = item.account_type == 1 ? `${this.$t('transferInto.accountName[0]')}\n(${item.account_no})` : `${this.$t('transferInto.accountName[1]')}\n(${item.account_no})`
            return item;
          })
          this.formData.a_account_type = this.$route.query.account_type;
          this.formData.a_account = this.$route.query.account_no;
          this.arrenyColumns = this.$t('transferInto.lang2.colums');
          this.lang = localStorage.getItem('localLang') || 'zh-CN';
          this.handleAccountData();
          this.updateTopRightButton();
        })
    },
    handleAccountData() {
      const accountInfo = this.withdrawalAccount.find(item => item.account_no == this.formData.a_account) || {};
      this.accountInfo.usd = accountInfo.usd_can_draw ? parseFloat(accountInfo.usd_can_draw) || '' : '';
      this.accountInfo.hkd = accountInfo.hkd_can_draw ? parseFloat(accountInfo.hkd_can_draw) || '' : '';
      this.accountInfo.cnh = accountInfo.cnh_can_draw ? parseFloat(accountInfo.cnh_can_draw) || '' : '';
      this.depositAccount = this.withdrawalAccount.filter( item => item.account_no != this.formData.a_account );
    },
    showPicker(type = 1) {
      this.currentColumns = this.arrenyColumns;
      this.currentDefaultIndex = this.currentColumns.findIndex(item => item.value == this.formData.transfer_currency);
      this.clickType = type;
      this.showPickerPopup = true;
    },
    onPickerConfirm(selectedOption) {
      this.formData.transfer_currency = selectedOption.value;
      this.coinTypeText = selectedOption.text;
      this.showPickerPopup = false;
    },
    inputFocus(id){
      this.inputFocusId = id;
    },
    selectAccount( item ) {
      if ( this.clickType == 1 ) {
        this.formData.a_account_type = item.account_type;
        this.formData.a_account = item.account_no;
        this.formData.b_account_type = '';
        this.formData.b_account = '';
        this.updateTopRightButton();
        this.handleAccountData();
      } else {
        this.formData.b_account_type = item.account_type;
        this.formData.b_account = item.account_no;
      }
      this.showAccountPicker = false;
    },
    inputBlur(){
      this.inputFocusId = null;
    },
    submit() {
      this.isClickNext = true;
      if ( this.isButtonDisabled ) return false;
      
      this.checkPasswordShow = true;
    },
    // 处理用户输入金额
    handleAmountInput(value) {
      this.formData.amount = validateInput(value);
      this.$nextTick(() => {
        this.$refs.amountField.$el.querySelector('input').value = validateInput(value);
      });
    },
    selectedAmount() {
      this.formData.is_all = this.formData.is_all == 1 ? 0 : 1;
      if ( this.formData.is_all == 1 ) {
        const balanceMap = {
          'USD': this.accountInfo.usd,
          'HKD': this.accountInfo.hkd,
          'CNH': this.accountInfo.cnh,
        };
        this.formData.amount = balanceMap[this.formData.transfer_currency];
      } else {
        this.formData.amount = ''
      }
    },
    clearAmount() {
      this.formData.amount = '';
      this.formData.is_all = 0;
    },
    async handleBeforeClose(action, done) {
      // 取消直接关闭弹窗
      if ( action != 'confirm' ) {
        this.checkPasswordShow = false;
        done()
        return false;
      }
      // 确认带上done，作用是控制弹窗是否关闭 done(false)不允许关闭
      this.confirm(done);
    },
    eyeSwitch() {
      this.eyeIsOpen = !this.eyeIsOpen;
    },
    showAccount( type ) {
      this.currentColumns = type === 1 ? this.withdrawalAccount : this.depositAccount;
      this.clickType = type;
      this.showAccountPicker = true;
    },
    passwordErrorPromptConfirm(errCode) {
      this.pwdErrPromptOption.show = false;
      if (errCode === 100173) {
        this.checkPasswordShow = true;
        this.$refs["custom-field-password"].setInputFocus();
        setTimeout(() => {
          this.$refs["custom-field-password"].setInputFocus();
        }, 500);
      }
    },
    getAmount(num){
        return localeString(num)
    },
    confirm(done) {
      if (this.checkPassword === "") {
        Toast(this.$t("fundsTransfer.f000011"));
        done(false);
      } else {
        this.$apis.checkPasswordFail({ password: this.checkPassword }).then((res) => {
            done(false);
            if (res.code) {
              done(false);
              if (res.code === 100174 || res.code === 100173) {
                this.pwdErrPromptOption.errCode = res.code;
                this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
                this.pwdErrPromptOption.show = true;
                this.$refs["password-error-prompt-el"].show = true;
                done(false);
              }
            } else {
              this.formData.type = this.formData.a_account_type;
              const query = {
                ...this.formData, 
                amount: this.formData.is_all == 1 ? 0 : this.formData.amount
              }
              this.$apis.postTransfer(query).then( res => {
                done();
                this.checkPasswordShow = false;
                this.submitSuccess = true;
              })
            }
          });
      }
    },
    okay() {
      this.isShowOpenDialog = false
      const browser = getBrowser();
      const isAPP = browser.isApp;
      if ( isAPP ) {
        closeWebView()
      } else {
        this.$router.go(-1);
      }
    },
    // 更新右上角按钮信息
    updateTopRightButton() {
      webViewRightButton({
        url: {
            type: 1,
            url: `/app-pages/transferRecords?account_no=${this.formData.a_account}&account_type=${this.formData.a_account_type}`
        },
        isDisplay: true,
        title: this.$t('fundsTransfer.f000012')
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/styles.less';
.fundsTransfer {
  padding: 24px 32px 0px;
  .ipt-main {
    .val {
      display: flex;
      align-items: center;
      .icon {
        width: 36px;
        height: 36px;
        margin-right: 12px;
      }
      
    }
  }
  .container {
    display: flex;
    justify-content: space-between;
    background: #eef1f9;
    border-radius: 24px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 10px;
      box-sizing: border-box;

      .top {
        font-size: 24px;
        color: #747377;
      }
      .bottom {
        color: #17161C;
        font-size: 28px;
        font-weight: 500;
      }

      // 左块
      &.left {
        align-items: flex-start;
        text-align: left;
      }

      // 中块
      &.center {
        align-items: flex-start;
        text-align: left;
      }

      // 右块
      &.right {
        align-items: flex-end;
        text-align: right;
      }
    }
  }
  .nav-buttons {
    padding-top: 50px;
  }
  &.en {
    .ipt-main {
      .val {
        span {
          white-space: pre-wrap;
        }
      }
    }
  }
}
.black-theme {
  .container {
    background: #2A2F3A;
    .top {
      color: #9D9D9F !important;
    }
    .bottom {
      color: #FFFFFF !important;
    }
  }
}
.empty-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    
    .empty-img {
        width: 130px;
        height: 140px;
    }
    
    .empty-text {
        font-size: 28px;
        color: #747377;
    }
}
</style>